export const FAST_INTERVAL = 10000

export const SLOW_INTERVAL = 60000

export const REFRESH_BLOCK_INTERVAL = 6000
